import { NodeDisplayData, PartialButFor } from 'sigma/types';
import { Settings } from 'sigma/settings';
import { SigmaNode, WYMMO_ITEM } from './types';

const TEXT_COLOR = '#000000';
const SUBTEXT_COLOR = '#666666';

/**
 * This function draw in the input canvas 2D context a rectangle.
 * It only deals with tracing the path, and does not fill or stroke.
 */
export function drawRoundRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  width: number,
  height: number,
  radius: number
): void {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.lineTo(x + width - radius, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
  ctx.lineTo(x + width, y + height - radius);
  ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
  ctx.lineTo(x + radius, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
  ctx.lineTo(x, y + radius);
  ctx.quadraticCurveTo(x, y, x + radius, y);
  ctx.closePath();
}

/**
 * Custom hover renderer
 */
export function drawHover(context: CanvasRenderingContext2D, data: SigmaNode, settings: Settings) {
  const size = settings.labelSize;
  const font = settings.labelFont;
  const weight = settings.labelWeight;
  const topLabelSize = size - 2;
  const bottomLabelSize = size - 2;

  const label = data.label;
  // const topLabel = data.wymmoType;
  const topLabel = false;
  const bottomLabel = data.wymmoType === WYMMO_ITEM ? data.wymmoTagLabels.join(', ') : null;

  // Then we draw the label background
  context.beginPath();
  context.fillStyle = '#fff';
  context.shadowOffsetX = 0;
  context.shadowOffsetY = 2;
  context.shadowBlur = 8;
  context.shadowColor = '#000';

  context.font = `${weight} ${size}px ${font}`;
  const labelWidth = context.measureText(label).width;
  context.font = `${weight} ${topLabelSize}px ${font}`;
  const topLabelWidth = topLabel ? context.measureText(topLabel).width : 0;
  context.font = `${weight} ${bottomLabelSize}px ${font}`;
  const bottomLabelWidth = bottomLabel ? context.measureText(bottomLabel).width : 0;

  const textWidth = Math.max(labelWidth, topLabelWidth, bottomLabelWidth);

  const x = Math.round(data.x);
  const y = Math.round(data.y);
  const w = Math.round(textWidth + size / 2 + data.size + 3);
  const hLabel = Math.round(size / 2 + 4);
  const hTopLabel = topLabel ? Math.round(topLabelSize / 2 + 9) : 0;
  const hBottomLabel = bottomLabel ? Math.round(bottomLabelSize / 2 + 9) : 0;

  if (topLabel) {
    drawRoundRect(context, x, y - hTopLabel - 12, w, hBottomLabel + hLabel + hTopLabel + 12, 5);
  } else {
    drawRoundRect(context, x, y - 12, w, hBottomLabel + hLabel + 12, 5);
  }
  context.closePath();
  context.fill();

  context.shadowOffsetX = 0;
  context.shadowOffsetY = 0;
  context.shadowBlur = 0;

  // And finally we draw the labels
  context.fillStyle = TEXT_COLOR;
  context.font = `${weight} ${size}px ${font}`;
  context.fillText(label, data.x + data.size + 3, data.y + size / 3);

  if (topLabel) {
    context.fillStyle = TEXT_COLOR;
    context.font = `${weight} ${topLabelSize}px ${font}`;
    context.fillText(topLabel, data.x + data.size + 3, data.y - (2 * size) / 3 - 2);
  }

  if (bottomLabel) {
    context.fillStyle = SUBTEXT_COLOR;
    context.font = `${weight} ${topLabelSize}px ${font}`;
    context.fillText(bottomLabel, data.x + data.size + 3, data.y + size / 3 + 3 + topLabelSize);
  }
}

/**
 * Custom label renderer
 */
export default function drawLabel(
  context: CanvasRenderingContext2D,
  data: PartialButFor<NodeDisplayData, 'x' | 'y' | 'size' | 'label' | 'color'>,
  settings: Settings
): void {
  if (!data.label) return;

  const size = settings.labelSize,
    font = settings.labelFont,
    weight = settings.labelWeight;

  context.font = `${weight} ${size}px ${font}`;
  const width = context.measureText(data.label).width + 8;

  context.fillStyle = '#ffffffcc';
  context.fillRect(data.x + data.size, data.y + size / 3 - 15, width, 20);

  context.fillStyle = '#000';
  context.fillText(data.label, data.x + data.size + 3, data.y + size / 3);
}
